class LocalStorageService {
  static getAccessToken(): string {
    const stored = localStorage.getItem("authStore");

    if (!stored) {
      return "";
    }

    try {
      const authStore = JSON.parse(stored);

      return authStore?.state?.token ?? "";
    } catch {
      return "";
    }
  }
}

export default LocalStorageService;
